import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
const firebase = require('firebase');
require('firebase/firestore');
// Your web app's Firebase configuration
firebase.initializeApp({
	apiKey: 'AIzaSyBsN5QFV2ZxtkJAjioess7ZITnWDj0sZ3c',
	authDomain: 'evernote-clone-bd156.firebaseapp.com',
	databaseURL: 'https://evernote-clone-bd156.firebaseio.com',
	projectId: 'evernote-clone-bd156',
	storageBucket: 'evernote-clone-bd156.appspot.com',
	messagingSenderId: '396687825190',
	appId: '1:396687825190:web:e06645482c79c982'
});

ReactDOM.render(<App />, document.getElementById('evernote-container'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
